import { ISearchPageFilter } from '../../api/types/searchPageApiTypes';
import { MakeModelOption } from './MakeModelKeywordSearch.typed';

type FilterOption = {
  displayName: string;
  value: string;
  count?: string;
};

export default function extractMakeOptions(
  motorSearchFilters: ISearchPageFilter[],
): Array<MakeModelOption> {
  const allMakesOptions = extractMakeFilterOptions(motorSearchFilters, 'all');
  const popularMakesOptions = extractMakeFilterOptions(
    motorSearchFilters,
    'popular',
  );

  return [
    ...addGroupLabelToFirstOption(popularMakesOptions, 'Popular makes'),
    ...addGroupLabelToFirstOption(allMakesOptions, 'All makes'),
  ];
}

function extractMakeFilterOptions(
  motorSearchFilters: ISearchPageFilter[],
  property: 'all' | 'popular',
): Array<MakeModelOption> {
  const filter = motorSearchFilters.find(
    (filter) => filter.name === 'makeModel',
  );
  const options = filter?.subFilters?.[0]?.values?.[0]?.[property] as
    | FilterOption[]
    | undefined;

  return (
    options?.map((option) => {
      return {
        label: option.displayName,
        value:
          option.value === ''
            ? null
            : {
                make: option.value,
              },
        count: option.count ?? null,
      };
    }) ?? []
  );
}

function addGroupLabelToFirstOption(
  options: Array<MakeModelOption>,
  groupLabel: string,
) {
  return options.map((option, index) => {
    if (index === 0) {
      return { ...option, groupLabel };
    }
    return option;
  });
}
